import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import screen from 'superior-mq';
import { bp } from 'Styles/helpers';
import Wave from '../svg/wave.svg';

export default class Waves extends PureComponent {
  static propTypes = {
    offset: PropTypes.number,
    position: PropTypes.oneOf(['top', 'bottom']),
    alignment: PropTypes.oneOf(['top', 'bottom']),
    color: PropTypes.string,
    animateIn: PropTypes.bool,
    animateReady: PropTypes.bool,
    height: PropTypes.number,
    styles: PropTypes.string,
  }

  constructor() {
    super();
    this.wavesRef = React.createRef();
  }

  makeLines() {
    const hUnit = 36.2;
    const containerHeight = this.props.height;
    const waveCount = Math.floor(containerHeight / hUnit);
    const totalWaves = this.props.bleed ? waveCount + 4 : waveCount;
    const tmp = [];

    for (let i = 0; i < totalWaves; i++) {
      tmp.push(i);
    }
    return (tmp.map(i => (
      <Wave key={`svg-${i}`} />
    )));
  }

  componentDidMount() {
    if (this.props.animateIn) {
      const allPaths = this.wavesRef.current.querySelectorAll('path');

      this.tl = new TimelineMax();
      this.tl
        .add('sync')
        .staggerFrom(allPaths, 0.5, { opacity: 0, ease: Power3.easeIn }, -0.069, 'sync')
        .staggerTo(allPaths, 2.5, { strokeDashoffset: 0, ease: Power3.easeIn }, -0.069, 'sync');
    }
  }

  componentWillUnmount() {
    if (this.props.animateIn) {
      this.tl.kill();
    }
  }

  render() {
    return (
      <WavesContainer
        offset={this.props.offset}
        position={this.props.position}
        alignment={this.props.alignment}
        color={this.props.color}
        animateIn={this.props.animateIn}
        animateReady={this.props.animateReady}
        height={this.props.height}
        ref={this.wavesRef}
        styles={this.props.styles}
      >
        <SVGWrapper inverted={this.props.inverted} alignment={this.props.alignment}>
          {this.makeLines()}
        </SVGWrapper>
      </WavesContainer>
    );
  }
}

const WavesContainer = styled.div`
  position: absolute;
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  z-index: 1;
  pointer-events: none;
  ${props => props.position ? props.position : 'top'}: 0;
  color: ${props => props.color ? props.color : '#16191a'};

  &::after {
    content: "";
    padding-bottom: ${props => (props.height / 1800) * 100}%;
    width: 100%;
    position: relative;
    display: block;

    ${props => screen.below(bp.mobile, `
      padding-bottom: ${(props.height / 1800) * 125}%;
    `)}

    ${props => screen.below(bp.mobileSm, `
      padding-bottom: ${(props.height / 1800) * 200}%;
    `)}
  }

  svg {
    position: relative;
    margin-${props => props.alignment ? props.alignment : 'top'}: -6.43%; /* stylelint-disable-line property-no-unknown */
    display: block;

    path {
      fill: none;
      stroke: currentColor;
      stroke-width: 4;
      stroke-linecap: round;
      stroke-dashoffset: ${props => props.animateIn || props.animateReady ? 'var(--stroke-offset)' : 0};
    }
  }

  ${props => props.styles && css`
    ${props.styles}
  `}
`;

const SVGWrapper = styled.div`
  --stroke-offset: ${props => props.inverted ? -1423.5 : 1423.5};
  position: absolute;
  width: 100%;
  overflow: hidden;
  ${props => props.alignment === 'bottom' ? 'bottom' : 'top'}: ${props => props.alignment === 'bottom' ? '-5px' : '0'};
  text-align: center;
  ${props => props.inverted ? 'transform: scaleX(-1);' : null}

  ${screen.below(bp.mobile, `
    width: 125%;
    margin-left: -12.5%;
  `)}

  ${screen.below(bp.mobileSm, `
    width: 200%;
    margin-left: -50%;
  `)}
`;
